// Tenantra Inc. - Roommate ID check (Didit only, no credit check) from the email link
import { useEffect, useState } from 'react';
import { AlertCircle, CheckCircle2, Loader2, ShieldCheck } from 'lucide-react';
import api from '@/services/api';
import { Shell } from './OnboardPage';

const errText = (e) => { const d = e?.response?.data?.detail; return typeof d === 'string' ? d : 'Something went wrong. Please try again.'; };

export default function RoommateIdPage() {
  const token = window.location.pathname.split('/').pop();
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/onboarding/public/roommate/${token}`).then(r => setD(r.data)).catch(e => setErr(errText(e)));
  useEffect(() => { load(); }, []); // eslint-disable-line
  const start = async () => { setBusy(true); setErr(''); try { const r = await api.post(`/onboarding/public/roommate/${token}/id-session`); window.location.href = r.data.url; } catch (e) { setErr(errText(e)); setBusy(false); } };
  if (!d && !err) return <Shell><div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-stone-400" /></div></Shell>;
  return (
    <Shell>
      <section className="bg-white border border-stone-200 rounded-lg p-5 space-y-4" data-testid="roommate-page">
        {d && d.id_status === 'verified' ? (
          <><CheckCircle2 className="w-10 h-10 text-teal-600" /><h1 className="text-lg font-semibold text-stone-900" data-testid="roommate-verified">Thanks, {d.full_name.split(' ')[0]}. Your ID is verified.</h1><p className="text-sm text-stone-600">Nothing else is needed from you.</p></>
        ) : d ? (
          <>
            <div className="flex items-start gap-3"><ShieldCheck className="w-6 h-6 text-teal-600 flex-shrink-0" /><div><h1 className="text-lg font-semibold text-stone-900">Quick ID check for {d.address}</h1>
              <p className="text-sm text-stone-600">Hi {d.full_name.split(' ')[0]}, you were listed as a roommate. Please verify your ID with a photo of your government ID and a face scan. There is no credit check.</p></div></div>
            {d.id_status === 'pending' && d.started && <p className="text-sm text-stone-600" data-testid="roommate-pending">We're checking your verification. Refresh this page in a minute.</p>}
            <button disabled={busy} onClick={start} className="h-11 w-full rounded-md bg-teal-600 hover:bg-teal-700 text-white text-sm font-medium inline-flex items-center justify-center gap-2 disabled:opacity-50" data-testid="roommate-start">{busy && <Loader2 className="w-4 h-4 animate-spin" />} {d.started ? 'Start again' : 'Verify my ID'}</button>
          </>
        ) : null}
        {err && <p className="text-sm text-red-600 flex gap-2" data-testid="roommate-error"><AlertCircle className="w-4 h-4" />{err}</p>}
      </section>
    </Shell>
  );
}
